import { ReactComponent as UserLogo } from "../../assets/icons/UserLogo.svg";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import ChatBubbleLeftEllipsisIcon from "@heroicons/react/24/outline/ChatBubbleLeftEllipsisIcon";
import SvgMapper from "../features/common/SvgMapper";

export const getDefaultIconMapper = () => ({
  totalStudents: <UserLogo />,
  activeInterviews: (
    <ChatBubbleLeftRightIcon className="w-8 h-8 text-green-600 bg-green-50 rounded-xl p-1" />
  ),
  completedInterviews: (
    <CreditCardIcon className="w-8 h-8 text-yellow-600 bg-yellow-50 rounded-xl p-1" />
  ),
  interviewConfig: (
    <ChatBubbleLeftEllipsisIcon className="w-8 h-8 text-purple-600 bg-purple-50 rounded-xl p-1" />
  ),
  totalInterview: (
    <ChatBubbleLeftRightIcon className="w-8 h-8 text-green-600 bg-green-50 rounded-xl p-1" />
  ),
  totalCompletedInterview: (
    <CreditCardIcon className="w-8 h-8 text-yellow-600 bg-yellow-50 rounded-xl p-1" />
  ),
  totalScheduledInterview: SvgMapper.logo("w-8 h-8 text-purple-600"),
});

